import "react-toastify/dist/ReactToastify.css";

import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// import { I18nProvider } from "./contexts/i18n/i18nProvider";
import { LocationProvider } from "./contexts/locationContext";
import { MediaQueryProvider } from "./contexts/mediaQueryProvider/MediaQueryProvider";
import { OrganizationProvider } from "./contexts/organizations/organizationsContext";
import { LayoutProvider, LayoutSplashScreen } from "./layout/core";
import { AzureLoginVerifier } from "./pages/auth/components/AzureLoginVerifier";

const App = () => {
  useEffect(() => {
    const documentElement = document.documentElement;
    if (documentElement) {
      documentElement.setAttribute(
        "app-version",
        process.env.REACT_APP_VERSION || "0.1.0",
      );
    }
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LocationProvider>
        {/* <I18nProvider> */}
        <AzureLoginVerifier>
          <LayoutProvider>
            <OrganizationProvider>
              <MediaQueryProvider>
                <Outlet />
              </MediaQueryProvider>
            </OrganizationProvider>
          </LayoutProvider>
        </AzureLoginVerifier>
        {/* </I18nProvider> */}
      </LocationProvider>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick={true}
      />
    </Suspense>
  );
};

export { App };
